module.exports = __webpack_public_path__ + "img/6c813e27cc03eb185b9df1d8240bfef.99fe475a.jpg";